import {Injectable} from '@angular/core';
import {AbstractDataServiceDtoAdapter} from 'src/app/modules/core/service/v2/dataservice/adapter/abstractDataServiceDto.adapter';
import {TagDataService} from './tagData.service';
import {TagModel} from "../../../api/model/tag.model";
import {TagConverter} from "../../../api/model/tag.converter";


@Injectable({providedIn: 'root'})
export class TagDataServiceAdapter extends
    AbstractDataServiceDtoAdapter<TagModel, TagConverter> {
    constructor(dataService: TagDataService, converter: TagConverter) {
        super(dataService, converter);
    }
    newStoredEntityInstance(): TagModel {
        return new TagModel();
    }
}
